import { I18n } from "@assets/strings";
import React from "react";
import { ClipLoader } from "react-spinners";
import styled from "styled-components";
import { CourseStatus } from "@domain/lms/course/courseDraft";
import { useMyCourses } from "@domain/lms/course/hooks";
import { Secondary } from "@ui/components/containers/textBlocks";
import { CourseThumbnail } from "@ui/components/course/courseThumbnail";
import { InfiniteScroll } from "@ui/components/infiniteScroll";
import { desktop, gap, mobile } from "@ui/styles/utils";

interface MyCoursesListProps extends React.HTMLAttributes<HTMLDivElement> {
	status: CourseStatus | "ALL";
}

export const MyCoursesList: React.FC<MyCoursesListProps> = ({ status, ...htmlProps }) => {
	const { result: courses, fetchMore, loading, moreLoading, totalElements } = useMyCourses(status);

	return (
		<Container>
			{totalElements === 0 ? (
				<Secondary>
					{I18n.t(status === "ALL" ? "profile.course_self.empty_all" : "profile.course_self.empty")}
				</Secondary>
			) : (
				<InfiniteScroll onEndReached={fetchMore} loading={loading || moreLoading}>
					<Courses {...htmlProps}>
						{courses.map((course) =>
							course ? <CourseThumbnail key={course.id} course={course} displayStatus displayAuthorAsMe /> : undefined
						)}
						{loading && <ClipLoader />}
					</Courses>
				</InfiniteScroll>
			)}
		</Container>
	);
};

const Container = styled.div`
	display: flex;
	flex-direction: column;
`;

const Courses = styled.div`
	@media ${desktop} {
		display: grid;
		grid-template-columns: repeat(2, 1fr);
		grid-gap: 20px;
	}
	@media ${mobile} {
		${gap(20)};
	}
`;
